import * as React from 'react'

const DEFAULT_NAME = 'Backoffice'

interface Props {
  name?: string
  title?: string
}

export const Meta = React.memo(({ name, title }: Props) => {
  React.useEffect(() => {
    document.title = `${name || DEFAULT_NAME}${title ? ` — ${title}` : ''}`
  }, [name, title])

  return null
})
